export class CustomEventListener
{
    constructor(public type: string, public listener: Function, public arg: any)
    {
    }
}